var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.26 377.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.64,28.6V350.77H37.05V28.6Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.8,209.29c-2.39-44.93-5.26-98.95-4.78-139.1h-1.44C405.59,108,392.21,148.1,376,192.56l-56.88,156.3H287.53L235.42,195.43c-15.29-45.41-28.2-87-37.28-125.24h-1c-1,40.15-3.34,94.17-6.21,142.44l-8.6,138.14H142.69L165.16,28.6h53.06l55,155.83c13.38,39.68,24.37,75.05,32.5,108.51h1.43c8.13-32.51,19.6-67.88,33.94-108.51L398.42,28.6h53.06l20.07,322.17H430.92Z",
    transform: "translate(0 0)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 28.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.26,
    y: 349.17,
    width: 500,
    height: 28.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImLogo);
export default __webpack_public_path__ + "static/media/IMLogo.86c3548b.svg";
export { ForwardRef as ReactComponent };